module.exports = __webpack_public_path__ + "img/far-save.cd7c38fc.svg";